import { defineStore } from "pinia";
import { ref } from "vue";
import { getTimezones } from "@/api/catalogue";
import { showServerError } from "@/utils";

export const useTimezonesStore = defineStore('useTimezonesStore', () => {
    const items = ref<{ id: string, text: string, iana: string }[]>([]);
    let loading: Promise<void> | null = null;

    const getTimezoneItems = () => {
        if (loading) return loading;
        loading = (async () => {
            try {
                const data = await getTimezones();
                items.value = data
                    .sort((a, b) => a.current_offset.minutes - b.current_offset.minutes)
                    .map(i => ({ id: i.iana, text: `(${i.current_offset.label}) ${i.name}`, iana: i.iana }));
            } catch (err) {
                loading = null; // ponytail: reset so a failed load retries on next call
                showServerError(err, 'Ошибка загрузки таймзон');
            }
        })();
        return loading;
    };

    return {
        items,
        getTimezoneItems,
    };
});
